// extracted by mini-css-extract-plugin
module.exports = {"Recipe":"Recipe_Recipe__2ig1P","Remove":"Recipe_Remove__1PzQJ"};